"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatISOTimeLeft = exports.getTimeLeft = exports.useCountdown = void 0;
const moment_mini_1 = __importDefault(require("moment-mini"));
const react_1 = require("react");
const useInterval_1 = require("root/src/client/v2/common/hooks/useInterval");
function useCountdown(date) {
    const [timeLeft, setTimeLeft] = (0, react_1.useState)(() => {
        return new Date(date).getTime() - new Date().getTime();
    });
    const interval = (0, useInterval_1.useInterval)(() => {
        setTimeLeft(getTimeLeft(date));
    }, 1000);
    return {
        timeLeft,
        interval,
    };
}
exports.useCountdown = useCountdown;
/**
 * Returns time left in milliseconds
 * @param date
 * @example
 * getTimeLeft('2021-08-01T00:00:00.000Z') // 1627776000000
 * @returns
 */
function getTimeLeft(date) {
    return new Date(date).getTime() - new Date().getTime();
}
exports.getTimeLeft = getTimeLeft;
/**
 * Returns ISO time format ex. 04:10:52 (4 hours, 10 minutes, 52 seconds)
 */
function formatISOTimeLeft(timeLeft) {
    const duration = moment_mini_1.default.duration(timeLeft);
    const hours = Math.floor(duration.asHours()).toString().padStart(2, '0');
    const minutes = Math.floor(duration.minutes()).toString().padStart(2, '0');
    const seconds = Math.floor(duration.seconds()).toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
}
exports.formatISOTimeLeft = formatISOTimeLeft;
